import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isString } from 'lodash';
import './styles.scss';

export default class Select extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    optionKey: PropTypes.string.isRequired,
    optionValue: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
    options: PropTypes.array.isRequired,
    selectedOption: PropTypes.object.isRequired,
  };

  state = {
    open: false,
  };

  listener = undefined;

  open = () => {
    if (this.state.open) {
      this.close();
    } else {
      this.setState({ open: true }, () => {
        setTimeout(() => {
          window.addEventListener('click', this.close);
        });
      });
    }
  };

  close = () => {
    this.setState({ open: false }, () => window.removeEventListener('click', this.close));
  };

  renderOptionValue = option => {
    const { open } = this.state;

    const { optionValue } = this.props;

    return isString(optionValue) ? option[optionValue] : optionValue(option, open);
  };

  render() {
    const { className, selectedOption, onSelect, options, optionKey, label } = this.props;
    const { open } = this.state;

    return (
      <div className={classnames('select', className)}>
        {label && <p className="select-label"> {label} </p>}

        <div className={classnames('dropdown-select', open && 'open')}>
          {open ? (
            options.map(option => (
              <div key={option[optionKey]} onClick={() => onSelect(option)}>
                {this.renderOptionValue(option)}
              </div>
            ))
          ) : (
            <div className="dropdown-selection" onClick={this.open}>
              <div className="dropdown-selection-selected" key={selectedOption[optionKey]}>
                {this.renderOptionValue(selectedOption)}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
